export  const config = {
    basePath: '',
    GA_ID: 'G-BBM3ELB6JC',
}
